import styled from 'styled-components';
import React from 'react';
import { typeCSS } from '@utils/TypeCSS.styles';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { TagCategory } from './TagCategory';
import { ITagCategoryType } from './types';

const StyledTagCategory = React.memo(styled(TagCategory)`
  --category-color: ${props => props.category.color};
  .CategoryRow {
    padding: 12px 0px 12px 8px;
    display: flex;
    column-gap: 16px;
    align-items: center;
    cursor: pointer;
  }

  .mantine-Checkbox-root {
    cursor: pointer;
    display: inline-flex;
  }
  .mantine-Checkbox-input {
    border-color: ${COLORS_FLAT.n400};
    cursor: pointer;
  }
  .mantine-Checkbox-input:checked {
    border-color: ${COLORS_FLAT.b401};
  }
  .CategoryrowTitle {
    display: flex;
    column-gap: 8px;
    align-items: center;
  }
  .IconCircle {
    width: 16px;
    height: 16px;
    border-radius: 50%;

    background-color: var(--category-color);
  }
  .H400 {
    ${typeCSS(TYPOGRAPHY_FLAT.h400)}
  }
  .CategoryRow_Tag {
    display: flex;
    column-gap: 48px;
    align-items: center;
    padding: 8px 0px 8px 8px;
  }
`);

export default StyledTagCategory as ITagCategoryType;
